import React from "react";
import PropTypes from "prop-types";
import { Spin } from "antd";

export const LoadingState = ({ label = "Loading...", minHeight = "section", variant = "loading" }) => (
    <div className={`hms-loading-state hms-loading-state--${minHeight} hms-loading-state--${variant}`} role={variant === "error" ? "alert" : "status"}>
        {variant === "loading" ? <Spin /> : null}
        <span>{label}</span>
    </div>
);

LoadingState.propTypes = {
    label: PropTypes.string,
    minHeight: PropTypes.oneOf(["compact", "section", "page"]),
    variant: PropTypes.oneOf(["loading", "error"]),
};
